import pluralize from '@iez/lib/pluralize/'

export default ({
  count,
  words,
  hideCount
}) =>
  `${hideCount ? `` : `${count} `}${
    words
      .split(` `)
      .map(
        word  =>
          pluralize({ count, word, hideCount: true })
      ).join(` `)
  }`
